import { toStreamID } from '@streamr/utils';
import { Env } from '../Env';
export function generateStreamId() {
    return toStreamID(`/${Math.random().toString(36).substring(2)}`, Env.DEFAULT_STREAM_DOMAIN);
}
export function formFullStreamId(fullOrShortStreamId) {
    if (fullOrShortStreamId.includes('/')) {
        return toStreamID(fullOrShortStreamId);
    }
    return toStreamID(`/${fullOrShortStreamId}`, Env.DEFAULT_STREAM_DOMAIN);
}
export function formShortStreamId(fullStreamId) {
    const streamIdPrefix = `${Env.DEFAULT_STREAM_DOMAIN}/`;
    return fullStreamId.startsWith(streamIdPrefix)
        ? fullStreamId.slice(streamIdPrefix.length)
        : fullStreamId;
}
